<template>
  <div>
    <HeaderBreadcrumbs
      :items="[
        { label: 'Admin', to: '/user-admin' },
        { label: item?.email }
      ]"
      :title="item?.email"
    />

    <div class="w-full p-6 my-3 bg-white rounded-lg shadow-sm">
      <div class="flex items-center justify-between mb-6">
        <h4 class="text-xl font-bold text-gray-900">Admin Details</h4>
        <!-- Hidden Show Secret Key button -->
        <!--
        <Button
          v-if="roleNumber === SUPER_ADMIN && !isBlock"
          @click="openPasswordModal"
          variant="outlined"
          color="alternative"
          class="text-sm"
        >
          <template #iconBefore>
            <EyeFilled className="w-4 h-4" />
          </template>
          Show Secret Key
        </Button>
        <div v-else-if="isBlock && roleNumber === SUPER_ADMIN">
          <Label variant="red" class="text-sm">{{ timerOutput }}</Label>
        </div>
        -->
      </div>

      <div class="grid grid-cols-2 gap-x-12 gap-y-6">
        <div class="space-y-6">
          <div>
            <DescriptionTerm class="mb-1 text-sm font-medium text-gray-600">Email</DescriptionTerm>
            <DescriptionDetail :isLoading="isLoadingAdmin" class="text-gray-900 lower-case">{{ email || '-' }}</DescriptionDetail>
          </div>

          <div>
            <DescriptionTerm class="mb-1 text-sm font-medium text-gray-600">Role</DescriptionTerm>
            <DescriptionDetail :isLoading="isLoadingAdmin" class="text-gray-900">{{ role || '-' }}</DescriptionDetail>
          </div>

          <div>
            <DescriptionTerm class="mb-1 text-sm font-medium text-gray-600">Publisher Group</DescriptionTerm>
            <DescriptionDetail :isLoading="isLoadingAdmin" class="text-gray-900 capitalize">{{ group || '-' }}</DescriptionDetail>
          </div>
        </div>

        <div>
          <div>
            <DescriptionTerm class="mb-1 text-sm font-medium text-gray-600">Status</DescriptionTerm>
            <DescriptionDetail :isLoading="isLoadingAdmin">
              <Label :variant="isActive ? 'green' : 'gray'" class="text-sm">
                {{ isActive ? 'Active' : 'Inactive' }}
              </Label>
            </DescriptionDetail>
          </div>
        </div>
      </div>
    </div>

    <!-- Password Input Modal -->
    <PasswordInputModal
      :isVisible="showPasswordModal"
      :hasError="passwordError"
      :errorMessage="passwordErrorMessage"
      @submit="handlePasswordSubmit"
      @close="closePasswordModal"
    />

    <!-- Message Alert Modal -->
    <MessageAlertModal
      :isVisible="showMessageAlertModal"
      :title="messageAlertTitle"
      :message="messageAlertContent"
      :confirmButtonText="messageAlertConfirmText"
      @close="closeMessageAlert"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import constant from '@/store/constant';

import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs';
// import Button from '@/components/ui/Button';
import DescriptionTerm from '@/components/ui/DescriptionTerm';
import DescriptionDetail from '@/components/ui/DescriptionDetail';
import Label from '@/components/ui/Label';
// import EyeFilled from '@/components/icons/EyeFilled';
// import PasswordInputModal from '@/components/ui/PasswordInputModal';
// import MessageAlertModal from '@/components/ui/MessageAlertModal';

const second = 30;
const jumlah = 3;

export default {
  name: 'UserAdminDisplayNew',
  components: {
    HeaderBreadcrumbs,
    // Button,
    DescriptionTerm,
    DescriptionDetail,
    Label,
    // EyeFilled,
    // PasswordInputModal,
    // MessageAlertModal
  },
  data() {
    return {
      email: '',
      isLoading: false,
      role: null,
      group: null,
      roleNumber: null,
      userId: null,
      isActive: true,
      isBlock: false,
      interval: null,
      countDownToTime: null,
      timerOutput: null,
      SUPER_ADMIN: constant.ROLES.SUPER_ADMIN,
      showPasswordModal: false,
      passwordError: false,
      passwordErrorMessage: 'Password does not match.',
      currentPasswordAttempt: 1,
      showMessageAlertModal: false,
      messageAlertTitle: 'Alert',
      messageAlertContent: '',
      messageAlertConfirmText: 'Ok',
    };
  },
  computed: {
    ...mapState({
      item: (state) => state.admin.item,
      successMessage: (state) => state.admin.successMessage,
      errorMessage: (state) => state.admin.errorMessage,
      isError: (state) => state.admin.isError,
      isLoadingAdmin: (state) => state.admin.isLoading,
    }),
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Display User Admin | Content Management System Ebooks Gramedia.com';
      },
    },
    item: function() {
      if (!Object.keys(this.item).length) return;
      this.getUserAdmin();
    },
    errorMessage: function() {
      if (!this.errorMessage) return;
    },
    isError: function() {
      if (!this.isError) return;
      this.alertMsg('Ops. Something Went Wrong. Please Try Again', 'error');
    },
  },
  created: function() {
    this.getLoginUser();
    const userID = this.$route.params.id;
    this.fetchUserAdminById({ id: userID });
  },
  mounted() {
    let localIsBlock = localStorage.getItem("isBlock");
    if (localIsBlock) {
      this.isBlock = localIsBlock;
      let timeEndBlockEnd = localStorage.getItem("timeBlockEnd");
      if (!timeEndBlockEnd) {
        let now = null;
        now = new Date();
        this.countDownToTime = now.setSeconds(now.getSeconds() + second);
      } else {
        this.countDownToTime = timeEndBlockEnd;
      }
      this.interval = setInterval(() => { this.startTimer() }, 1000);
    } else {
      this.isBlock = false;
    }
  },
  methods: {
    ...mapActions('admin', ['fetchUserAdminById', 'showSecret']),

    openPasswordModal() {
      this.showPasswordModal = true;
      this.passwordError = false;
      this.currentPasswordAttempt = 1;
    },

    closePasswordModal() {
      this.showPasswordModal = false;
      this.passwordError = false;
    },

    async handlePasswordSubmit(password) {
      const response = await this.showSecret({
        userId: this.userId,
        userEmail: this.item.email,
        password
      });

      let {
        result,
        message,
        secretKey,
        secretKeyIsNotExist,
      } = response;

      if (this.currentPasswordAttempt >= jumlah && result == false) {
        this.closePasswordModal();
        this.showMessageAlert('You Have Been Input Password More Than 3 Times, Your Account is Locked for 30 Seconds');
        let now = new Date();
        let nowPlusSecond = now.setSeconds(now.getSeconds() + second);
        this.countDownToTime = nowPlusSecond;
        this.isBlock = true;
        localStorage.setItem('isBlock', this.isBlock);
        localStorage.setItem("timeBlockEnd", nowPlusSecond);
        localStorage.setItem("timeBlockStart", now);
        this.interval = setInterval(() => { this.startTimer() }, 1000);
        return;
      }

      if (result == false && this.currentPasswordAttempt < jumlah && !secretKeyIsNotExist) {
        this.passwordError = true;
        this.passwordErrorMessage = message === 'Wrong Password' ? 'Password does not match.' : (message || 'Password does not match.');
        this.currentPasswordAttempt++;
        return;
      }

      if (secretKeyIsNotExist) {
        this.closePasswordModal();
        this.showMessageAlert(message);
        return;
      }

      if (result) {
        this.closePasswordModal();
        this.showMessageAlert(`<h5 style = 'color:red'> Do Not Give This Key to Others ${secretKey} </h5> <br/> `);
      }
    },

    async getInputPassword(counter = 1, text = null) {
      if (counter == jumlah + 1) return;
      const swalQueueStep = this.baseAlertMessage();
      if (!text) {
        text = 'Input Your Password';
      }
      let confirmPassword = await swalQueueStep.fire({
        title: ` ${text}  Try  ( ${counter} / ${jumlah} )`,
        input: 'password',
        currentProgressStep: counter,
        preConfirm: (login) => {
          this.password = login;
          return login;
        },
      });
      if (!confirmPassword.isConfirmed) return;
      const password = confirmPassword.value;
      const response = await this.showSecret({
        userId: this.userId,
        userEmail: this.item.email,
        password
      });
      let {
        result,
        message,
        secretKey,
        secretKeyIsNotExist,
      } = response;
      if (counter == jumlah && result == false) {
        this.showMessageAlert('You Have Been Input Password More Than 3 Times, Your Account is Locked for 30 Seconds');
        let now = new Date();
        let nowPlusSecond = now.setSeconds(now.getSeconds() + second);
        this.countDownToTime = nowPlusSecond;
        localStorage.setItem('isBlock', this.isBlock);
        localStorage.setItem("timeBlockEnd", nowPlusSecond);
        localStorage.setItem("timeBlockStart", now);
        this.interval = setInterval(() => { this.startTimer() }, 30);
      }
      if (result == false && counter <= jumlah && !secretKeyIsNotExist) {
        return this.getInputPassword(counter += 1, message);
      }
      if (secretKeyIsNotExist) {
        return this.showMessageAlert(message);
      }
      if (result) {
        this.showMessageAlert(`<h5 style = 'color:red'> Do Not Give This Key to Others ${secretKey} </h5> <br/> `);
      }
    },

    showMessageAlert(message, title = 'Alert', confirmText = 'Ok') {
      this.messageAlertTitle = title;
      this.messageAlertContent = message;
      this.messageAlertConfirmText = confirmText;
      this.showMessageAlertModal = true;
    },

    closeMessageAlert() {
      this.showMessageAlertModal = false;
    },

    baseAlertMessage() {
      return this.$swal.mixin({
        customClass: 'swal-wide',
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
      });
    },

    async getUserAdmin() {
      this.userId = this.$route.params.id;
      const data = this.item;
      console.log(data)
      if (data) {
        this.email = data.email;
        this.role = data.roles.name.replace(/\b\w/g, l => l.toUpperCase());
        this.group = this.group = data.group ? data.group.replace(/_/g, ' ') : '';

        this.isActive = data.is_active;
      }
    },

    startTimer: function() {
      const timeNow = new Date().getTime();
      let timeSessionEnd = this.countDownToTime;
      const timeDifference = timeSessionEnd - timeNow;
      const millisecondsInOneSecond = 1000;
      const millisecondsInOneMinute = millisecondsInOneSecond * 60;
      const remainderDifferenceInSeconds = (timeDifference % millisecondsInOneMinute) / millisecondsInOneSecond;
      const remainingSeconds = Math.floor(remainderDifferenceInSeconds);
      if (remainingSeconds == 0) {
        localStorage.removeItem("isBlock");
        localStorage.removeItem("timeBlockStart");
        localStorage.removeItem("timeBlockEnd");
        this.isBlock = false;
        clearInterval(this.interval);
        return null;
      } else if (remainingSeconds > 0) {
        this.isBlock = true;
        this.timerOutput = 'Your Account Blocked, Please Try Again In : ' + remainingSeconds + ' Seconds';
      } else if (remainingSeconds < 0) {
        localStorage.removeItem("isBlock");
        localStorage.removeItem("timeBlockStart");
        localStorage.removeItem("timeBlockEnd");
        clearInterval(this.interval);
        return null;
      }
    },

    async getLoginUser() {
      let auth = localStorage.getItem("session_auth");
      auth = JSON.parse(auth);
      const role_id = auth.role_id;
      this.roleNumber = role_id;
    },

    alertMsg(msg, type) {
      this.$swal({
        icon: type,
        toast: true,
        position: 'top-end',
        title: msg,
        timer: 10000,
        text: this.message,
      });
    },
  },
};
</script>

<style scoped>
.swal-wide {
  width: 750px !important;
}
</style>
